module.exports = __webpack_public_path__ + "img/trend-before-3.69188496.png";